import React from "react";
import industriesData from "../utils/industriesData";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import "./Industries.css";

function Industries() {
  return (
    <section className="industries-section container-fluid py-5">
      <div className="text-center mb-5">
        <h2 className="section-title">Industries We Serve</h2>
        <p className="section-subtitle">
          We understand that every industry has unique challenges. That’s why our solutions are tailored to fit each sector:
        </p>
      </div>
      <div className="container">
      <div className="row g-4">
        {industriesData.map((industry, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-4">
            <div className="industry-card p-4 h-100 text-center">
              <div className="industry-icon mb-3">
                <FontAwesomeIcon icon={industry.icon} />
              </div>
              <h5 className="industry-title">{industry.title}</h5>
              <p className="industry-description">{industry.description}</p>
            </div>
          </div>
        ))}
      </div>
      </div>
    </section>
  );
}

export default Industries;